<template>
    <div>
        <b-row class="toolbar-ptc">
            <b-col>
                <router-link :to="{ name: 'menu_list', params: { brandCode: searchBrandCode} }" class="btn btn-ptc1" tag="button">返回</router-link>
            </b-col>
            <b-col class="text-center title">線上點餐管理 / 商品分類設定 / 商品維護</b-col>
            <b-col>
            </b-col>
        </b-row>
        <div id="func-content">
                <b-card class="bg-default-card">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="p-4 box-shadow " header="Form Elements">
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="row">
                                            <label class="col-md-4 control-label" for="example-select">品牌：</label>
                                            <div class="col-md-8">
                                                {{ this.$route.params.brandCode }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="row">
                                            <label class="col-md-4 control-label" for="example-select">分類名稱：</label>
                                            <div class="col-md-8">
                                                {{ this.$route.params.menuname }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6" v-show='FunctionPermission > 1'>
                                        <div class="row">
                                            <label class="col-md-4 control-label" for="example-select">菜單分類：</label>
                                            <div class="col-md-8">
                                                <input type='radio' name="rdoType" value='1' v-model='model.OptionType'>
                                                <label for='OptionType2'>單品.群組</label>&nbsp;&nbsp;&nbsp;&nbsp;
                                                <input type='radio' name="rdoType" value='2' v-model='model.OptionType'>
                                                <label for='OptionType1'>POS套餐</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt-3" v-show='FunctionPermission > 1'>
                                    <div class="col-md-12">
                                        <div class="row">
                                            <label class="control-label col-md-2">上架期間：</label>
                                            <div class="col-md-3">
                                                <input type="date" class="form-control" v-model="model.sdate" max="9999-12-31" :min='min_date' >
                                                <div class="text-danger" v-if="valid_sdate&&!model.sdate">{{valid_sdate}}</div>
                                            </div>
                                            <label class="control-label">至</label>
                                            <div class="col-md-3">
                                                <input type="date" class="form-control" v-model="model.edate" max="9999-12-31"  :min='min_date' >
                                                <div class="text-danger" v-if="valid_edate">{{valid_edate}}</div>
                                            </div>
                                            <div class="col-md-3">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt-3" v-show='FunctionPermission > 1'>
                                    <label class="col-md-2 control-label" for="example-select">商品：</label>
                                            <div class="col-md-6">
                                                <multiselect v-model="model.OptionProduct1" :options="products" :multiple="true" :custom-label="nameWithLang" group-values="Detail" group-label="Attribute" :group-select="true" placeholder="請選擇" track-by="Name" label="Name" v-if="model.OptionType=='1'" :close-on-select="false" :show-labels="false">
                                                    <span slot="noResult">查無資料</span>
                                                </multiselect>
                                                <div class="text-danger" v-if="valid_OptionProduct1&&model.OptionType=='1'">{{valid_OptionProduct1}}</div>
                                                <multiselect v-model="model.OptionProduct2" :options="combos" :multiple="true" :custom-label="nameWithLang" placeholder="請選擇" label="Name" track-by="Name" v-if="model.OptionType=='2'" :close-on-select="false" :show-labels="false"></multiselect>
                                                <div class="text-danger" v-if="valid_OptionProduct2&&model.OptionType=='2'">{{valid_OptionProduct2}}</div>
                                            </div>
                                    <div class="col-md-4" >
                                        <button type="button" class="btn btn-warning text-white " @click="save()" v-show='FunctionPermission > 1'>新增</button>&nbsp;&nbsp;
                                        <button type="button" class="btn btn-outline-light" @click="reset()" v-show='FunctionPermission > 1'>重設</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </b-card>
            <!-- Second Data Table Starts Here-->
                    <b-card class="bg-default-card">
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="" header="Form Elements">
                                    <div class="float-right">
                                    <button type='button' class='btn btn-warning text-white' v-show='btn_order && FunctionPermission > 1' @click='editOrderBy' >重新排序</button>
                                    <!-- 排序用按鈕 -->
                                    <button type='button' class='btn btn-save' v-show='!btn_order && FunctionPermission > 1' @click='OrderByOpen'>儲存</button>
                                    <button type='button' class='btn btn-clear' v-show='!btn_order && FunctionPermission > 1' @click='orderCancel'>取消</button>
                                </div>
                                    <div class="table-responsive" style="padding-top:10px">
                                        <table id="mytable" class="table table-bordred table-striped">
                                            <thead>
                                                <tr>
                                                    <th>序號</th>
                                                    <th>商品編號</th>
                                                    <th>商品名稱</th>
                                                    <th>POS商品分類</th>
                                                    <th>菜單分類</th>
                                                    <th>上架日</th>
                                                    <th>下架日</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <draggable v-model='Datalist' element='tbody' :options="dragOptions">
                                                <tr v-for='(v, index) in Datalist' :key='v.id' :class="{ active: !v.status,active2: !v.producttypestatus }">
                                                    <td>{{ index + 1 }}</td>
                                                    <td>{{ v.productcode }}</td>
                                                    <td>{{ v.productname }}</td>
                                                    <td>{{ v.attributename }}</td>
                                                    <td>{{ v.producttypename}}</td>
                                                    <td>{{ v.enabledat }}</td>
                                                    <td>{{ v.disabledat }}</td>
                                                    <td>
                                                      <button class='btn-circle btn-circle-ptc1' :disabled='!btn_order' v-show='FunctionPermission > 1' @click='editByOpen(v)'><span class='fas fa-pencil-alt' title="編輯"></span></button>
                                                      <button class='btn-circle btn-circle-ptc1' :disabled='!btn_order' v-show='FunctionPermission > 1' @click='delByOpen(v)'><span class='fas fa-trash-alt' title="刪除"></span></button></td>
                                                </tr>
                                            </draggable>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-card>
            <!-- second row ends here -->
            <!-- Fourth Basic Table Starts Here-->
            <!-- Double Check Modal -->
            <b-modal ref="mdCheck" hide-footer title="新增商品">
            <b-container fluid>
                <form>
                <div class="row mb-3">
                    <label class="control-label">確定新增此商品 ?</label>
                </div>
                <div class="float-right">
                    <b-btn variant="primary" @click="confirm">確定</b-btn>
                    <b-btn variant="secondary" @click="cancel">取消</b-btn>
                </div>
                </form>
            </b-container>
            </b-modal>
            <!-- ReSort Check Modal -->
      <b-modal ref="mdOrder" hide-footer title="排序變更">
        <b-container fluid>
          <form>
            <div class="row mb-3">
              <label class="control-label">確定 {{sort_action==1? '放棄' : '儲存'}} 排序變更 ?</label>
            </div>
            <div class="float-right">
              <b-btn variant="primary" @click="orderConfirm">確定</b-btn>
              <b-btn variant="secondary" @click="mdOrderCancel">取消</b-btn>
            </div>
          </form>
        </b-container>
      </b-modal>
     <!-- Delete Check Modal -->
      <b-modal ref="mdDelete" hide-footer title="刪除">
        <b-container fluid>
          <form>
            <div class="row mb-3">
              <label class="control-label">確定刪除 {{md_title}} ?</label>
            </div>
            <div class="float-right">
              <b-btn variant="primary" @click="delConfirm">確定</b-btn>
              <b-btn variant="secondary" @click="delCancel">取消</b-btn>
            </div>
          </form>
        </b-container>
      </b-modal>
      <b-modal ref="mdEdit" :no-close-on-backdrop="true" hide-footer title="資料修改" size="lg">
            <div class="d-block">
                <div class="col-lg-12 col-12 mb-3">
                  <div class="row col-lg-12" style="padding-top:10px">
                                            <div class="col-md-2">
                                                <label class="control-label">分類名稱：</label>
                                            </div>
                                            <div class="col-md-10">
                                              {{this.$route.params.menuname}}
                                            </div>
                    </div>
                    <div class="row col-lg-12" style="padding-top:10px">
                                            <div class="col-md-2">
                                                <label class="control-label">商品名稱：</label>
                                            </div>
                                            <div class="col-md-10">
                                              {{md_title}}
                                            </div>
                    </div>
                    <div class="row col-lg-12" style="padding-top:10px">
                      <label class="control-label col-md-2">上架期間：</label>
                                            <div class="col-md-4">
                                                <input type="date" class="form-control" v-model="edit_sdate" max="9999-12-31" :min='min_date' >
                                                <div class="text-danger" v-if="valid_edit_sdate&&!edit_sdate">{{valid_edit_sdate}}</div>
                                            </div>
                                            <label class="control-label">至</label>
                                            <div class="col-md-4">
                                                <input type="date" class="form-control" v-model="edit_edate" max="9999-12-31"  :min='min_date' >
                                                <div class="text-danger" v-if="valid_edit_edate">{{valid_edit_edate}}</div>
                                            </div>
                                            <div class="col-md-3">
                                            </div>
                    </div>
                </div>
                <div class="cog-lg-12">
                    <div class="row float-right cog-lg-12">
                        <b-btn variant="primary"  @click="editsave(model1)">儲存</b-btn>&nbsp;
                        <b-btn variant="secondary"  @click="editCancel()">取消</b-btn>&nbsp;
                    </div>
                </div>
            </div>
        </b-modal>
        </div>
    </div>
</template>
<script>
import Vue from 'vue'
import miniToastr from 'mini-toastr'
import VueForm from 'vue-form'
import options from 'validations'
import axios from 'axios'
import {API_URL} from '../../../store/root.js'
import { getFunctionPermission } from '@/js/LoginUserFunction.js'
import Multiselect from 'vue-multiselect'
import draggable from 'vuedraggable'
Vue.use(VueForm, options)

export default {
  name: 'add_user',
  components: {
    Multiselect,
    draggable
  },
  data () {
    return {
      formstate: {},
      valid_errMsg: false,
      sort_action: 1,
      md_id: 0,
      md_title: '',
      min_date: '', // 可選的最小日期
      products: [], // 商品清單含group
      combos: [], // POS類別清單
      model: {
        OptionType: '1',
        sdate: '',
        edate: '9999-12-31',
        OptionProduct: [],
        OptionProduct1: [],
        OptionProduct2: []
      },
      Datalist: [],
      valid_OptionProduct1: '',
      valid_OptionProduct2: '',
      valid_sdate: '',
      valid_edate: '',
      valid_edit_errMsg: '',
      valid_edit_sdate: '',
      valid_edit_edate: '',
      sort_disabled: true, // 排序功能是否停用
      btn_order: true, // 上方[重新排序]按鈕是否顯示
      edit_sdate: '',
      edit_edate: '',
      searchBrandCode: ''
    }
  },
  created () {
    this.FunctionPermission = getFunctionPermission('F18') // 功能權限 帶入功能代碼
    if (this.FunctionPermission < 1) {
      this.$router.push({name: 'name'})
    }
    this.searchBrandCode = this.$route.params.brandCode

    this.setdate()
    this.getMenuItemList()
    this.getAllProducts()
    this.getAllCombos()
  },
  computed: {
    // 排序參數設定
    dragOptions () {
      return {
        disabled: this.sort_disabled
      }
    }
  },
  methods: {
    nameWithLang ({ Code, Name }) {
      return `${Code} — ${Name}`
    },
    save () {
      this.valid_errMsg = false
      if (this.model.OptionType === '1') {
        this.model.OptionProduct = this.model.OptionProduct1

        if (this.model.OptionProduct1 === undefined || this.model.OptionProduct1.length <= 0) {
          this.valid_errMsg = true
          this.valid_OptionProduct1 = '商品為必選'
        } else {
          this.valid_OptionProduct1 = ''
        }
        this.valid_OptionProduct2 = ''
      } else {
        this.model.OptionProduct = this.model.OptionProduct2

        if (this.model.OptionProduct2 === undefined || this.model.OptionProduct2.length <= 0) {
          this.valid_errMsg = true
          this.valid_OptionProduct2 = '商品為必選'
        } else {
          this.valid_OptionProduct2 = ''
        }
        this.valid_OptionProduct1 = ''
      }

      if (!this.model.sdate) {
        this.valid_errMsg = true
        this.valid_sdate = '上架期間(起)為必填'
      } else {
        this.valid_sdate = ''
      }
      if (!this.model.edate) {
        this.valid_errMsg = true
        this.valid_edate = '上架期間(迄)為必填'
      } else if (this.model.edate < this.model.sdate) {
        this.valid_errMsg = true
        this.valid_edate = '結束日期不得小於開始日期'
      } else {
        this.valid_edate = ''
      }
      if (this.valid_errMsg) {
        this.$parent.verificationErrMsg()
        return
      }
      this.$refs.mdCheck.show()
    },
    confirm () {
      this.$refs.mdCheck.hide()
      this.$parent.Loading = true

      return axios.post(API_URL + '/web/shopping/menuItemCreate/v1', {
        menuCategoryID: this.$route.params.menuid,
        optionType: this.model.OptionType,
        sdate: this.model.sdate,
        edate: this.model.edate,
        optionProduct: this.model.OptionProduct,
        brandCode: this.searchBrandCode,
      })
        .then((response) => {
          this.$store.commit('TOKEN', response.data.jwt)
          this.$parent.Loading = false

          if (response.data.result === '0000') {
            miniToastr.success('新增成功')
            this.afterEdit()
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '資料新增失敗')
            console.log(response.data.message)
          }
        })
        .catch((error) => {
          this.$parent.Loading = false
          miniToastr.error(error, '資料新增失敗')
          console.log(error)
        })
    },
    cancel () {
      this.$refs.mdCheck.hide()
    },
    // 取得已選商品列表
    getMenuItemList () {
      if (this.$route.params.menuid === undefined) {
        this.$router.push({ name: 'menu_list' })
        return
      }
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/shopping/getmenuitem/v1', {
        menucategoryid: this.$route.params.menuid
      })
        .then((response) => {
          if (response.data.result === '0000') {
            this.Datalist = response.data.data
            this.$store.commit('TOKEN', response.data.jwt)
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            console.log(response)
            miniToastr.error(response.data.message, '查詢失敗')
            console.log(response.data.message)
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          console.log('CATCH')
          console.log(error)
          this.$parent.Loading = false
        })
    },
    // 取得商品選單
    getAllProducts () {
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/shopping/menuProductList/v1', {
        menucategoryid: this.$route.params.menuid,
        brandCode: this.searchBrandCode
      })
        .then((response) => {
          this.$store.commit('TOKEN', response.data.jwt)
          this.$parent.Loading = false

          if (response.data.result === '0000') {
            this.products = response.data.data
            if (this.products === undefined) {
              this.combos = []
            }
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '商品資料讀取異常')
            console.log(response.data.message)
          }
        })
        .catch((error) => {
          this.$parent.Loading = false
          miniToastr.error(error, '商品資料讀取異常')
          console.log(error)
        })
    },
    // 取得套餐選單
    getAllCombos () {
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/shopping/menuPosComboList/v1', {
        menucategoryid: this.$route.params.menuid,
        brandCode: this.searchBrandCode
      })
        .then((response) => {
          this.$store.commit('TOKEN', response.data.jwt)
          this.$parent.Loading = false

          if (response.data.result === '0000') {
            this.combos = response.data.data
            if (this.combos === undefined) {
              this.combos = []
            }
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '商品資料讀取異常')
            console.log(response.data.message)
          }
        })
        .catch((error) => {
          this.$parent.Loading = false
          miniToastr.error(error, '商品資料讀取異常')
          console.log(error)
        })
    },
    reset () {
      this.model.OptionType = '1'
      this.model = {
        OptionType: '1',
        sdate: '',
        edate: '9999-12-31',
        OptionProduct: [],
        OptionProduct1: [],
        OptionProduct2: []
      }
    },
    afterEdit () {
      this.getMenuItemList()
      this.getAllProducts()
      this.getAllCombos()
      this.model.OptionProduct = []
      this.model.OptionProduct1 = []
      this.model.OptionProduct2 = []
    },
    setdate () {
      var date = new Date()
      var year = date.getFullYear()
      var mon = date.getMonth() + 1
      var day = date.getDate()

      if (mon < 10) {
        mon = '0' + mon
      }
      if (day < 10) {
        day = '0' + day
      }
      this.min_date = year + '-' + mon + '-' + day
    },
    // APP分類設定 - 按下重新排序按鈕
    editOrderBy () {
      this.btn_order = false
      this.sort_disabled = false // 啟用排序
    },
    // APP分類設定 - 按下排序儲存按鈕
    OrderByOpen () {
      this.$refs.mdOrder.show()
      this.sort_action = 2
    },
    // APP分類設定 - 儲存新的排序
    orderConfirm () {
      // 取得id與新的排序
      var arrAll = []
      this.Datalist.forEach(function (arrRole, Index) {
        arrAll.push({
          id: arrRole.id,
          sort: Index + 1
        })
      })
      // call API
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/shopping/menuItemOrder/v1', {
        data: arrAll,
        menucategoryid: this.$route.params.menuid
      })
        .then((response) => {
          if (response.data.result === '0000') {
            miniToastr.success('重新排序成功')
            this.sort_action = 2
            this.mdOrderCancel()
          } else {
            if (response.data.result === '0006') {
              this.$parent.logOut(false, true)
            } else {
              miniToastr.error(response.data.message, '錯誤訊息')
            }
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          miniToastr.error(error, '錯誤訊息')
          this.$parent.Loading = false
        })
    },
    mdOrderCancel () {
      this.$refs.mdOrder.hide()
      this.sort_action = 1
      this.orderCancel()
    },
    // APP分類設定 - 排序取消
    orderCancel () {
      this.btn_order = true
      this.sort_disabled = true // 停用排序
      this.getMenuItemList()
    },
    // APP分類設定 - 按下列表刪除按鈕
    delByOpen (item) {
      this.md_id = item.id
      this.md_title = item.productname
      this.$refs.mdDelete.show()
    },
    delCancel () {
      this.$refs.mdDelete.hide()
    },
    delConfirm () {
      this.$refs.mdDelete.hide()

      this.$parent.Loading = true
      return axios.post(API_URL + '/web/shopping/menuItemDelete/v1', {
        id: this.md_id,
        menucategoryid: this.$route.params.menuid
      })
        .then((response) => {
          this.$store.commit('TOKEN', response.data.jwt)
          this.$parent.Loading = false

          if (response.data.result === '0000') {
            miniToastr.success('已刪除')
            this.getMenuItemList()
            this.getAllProducts()
            this.getAllCombos()
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '資料變更錯誤')
            console.log(response.data.message)
          }
        })
        .catch((error) => {
          this.$parent.Loading = false
          miniToastr.error(error, '資料變更錯誤')
          console.log(error)
        })
    },
    // APP分類設定 - 按下列表編輯按鈕
    editByOpen (item) {
      this.md_id = item.id
      this.md_title = item.productname
      this.edit_sdate = item.enabledat
      this.edit_edate = item.disabledat
      this.$refs.mdEdit.show()
    },
    editCancel () {
      this.$refs.mdEdit.hide()
    },
    editConfirm () {
      this.$refs.mdEdit.hide()

      this.$parent.Loading = true
      return axios.post(API_URL + '/web/shopping/menuItemUpdate/v1', {
        id: this.md_id,
        sdate: this.edit_sdate,
        edate: this.edit_edate
      })
        .then((response) => {
          this.$store.commit('TOKEN', response.data.jwt)
          this.$parent.Loading = false

          if (response.data.result === '0000') {
            miniToastr.success('修改成功')
            this.getMenuItemList()
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '資料變更錯誤')
            console.log(response.data.message)
          }
        })
        .catch((error) => {
          this.$parent.Loading = false
          miniToastr.error(error, '資料變更錯誤')
          console.log(error)
        })
    },
    editsave () {
      this.valid_edit_errMsg = false
      if (!this.edit_sdate) {
        this.valid_edit_errMsg = true
        this.valid_edit_sdate = '上架期間(起)為必填'
      } else {
        this.valid_edit_sdate = ''
      }
      if (!this.edit_edate) {
        this.valid_edit_errMsg = true
        this.valid_edit_edate = '上架期間(迄)為必填'
      } else if (this.edit_edate < this.edit_sdate) {
        this.valid_edit_errMsg = true
        this.valid_edit_edate = '結束日期不得小於開始日期'
      } else {
        this.valid_edit_edate = ''
      }
      if (this.valid_edit_errMsg) {
        this.$parent.verificationErrMsg()
        return
      }
      this.editConfirm()
    }
  }
}
</script>
<style scoped>
.box-shadow {
  box-shadow: 0px 0px 1px 1px #cfcfcf;
}
.table-move>tbody>tr {
  cursor: move;
}
.active {
  color: orange;
}
.active2 {
  color: blue;
}
</style>



// WEBPACK FOOTER //
// src/pages/shopping/menu/ItemList.vue